

import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import axios from "axios";
import "./css/carousel.css";
import ChatbotIcon from "./ChatbotIcon";
import videoFile from "./videos/DJI_0021.mp4";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config/api";

const getImageUrl = (image) => {
  if (!image) return "";
  if (/^https?:\/\//i.test(image)) return image;

  return apiUrl(image);
};

const trimCarouselText = (text = "", maxLength = 180) => {
  const normalized = text.replace(/\s+/g, " ").trim();
  if (normalized.length <= maxLength) return normalized;

  const trimmed = normalized.slice(0, maxLength).replace(/\s+\S*$/, "");
  return `${trimmed || normalized.slice(0, maxLength)}...`;
};

const normalizeSlide = (item) => ({
  id: item.id,
  heading: item.heading || "",
  content: trimCarouselText(item.content),
  image: getImageUrl(item.image),
});

function CarouselOne() {
  const [slides, setSlides] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(apiUrl("/api/home-sections/carousel"))
      .then((res) => {
        const carouselSlides = Array.isArray(res.data)
          ? res.data.map(normalizeSlide)
          : [];

        setSlides(carouselSlides);
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <div
      className="carousel-parent"
      style={{ position: "relative", height: "100vh", overflow: "hidden" }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -1,
          filter: "brightness(0.6) contrast(1.2)",
        }}
      >
        <source src={videoFile} type="video/mp4" />
      </video>

      {/* Carousel */}
      <Carousel
        className="full-screen-carousel"
        indicators
        interval={4000}
        controls={false}
        pause={false}
        style={{ position: "relative", zIndex: 1, height: "100%" }}
      >
        {slides.map((slide, index) => (
          <Carousel.Item key={slide.id}>
            <div className="carousel-content">
              <div className="carousel-text">
                <h2 className="carousel-heading">{slide.heading}</h2>
                <p className="carousel-description">{slide.content}</p>

                <button
                  onClick={() => navigate(`/mediaPublications/${slide.id}`)}
                  className="carousel-button"
                >
                  Read More →
                </button>
              </div>

              {slide.image && (
                <img
                  className="carousel-image"
                  src={slide.image}
                  alt={`Slide ${index + 1}`}
                />
              )}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
      <ChatbotIcon />
    </div>
  );
}

export default CarouselOne;
